<script setup>
import { useIdentityStore } from '@/store/IdentityStore.js';
import { storeToRefs } from 'pinia';
import { watch } from 'vue';

const identityStore = useIdentityStore();
identityStore.init();
const { User } = storeToRefs(identityStore);

watch(User, () => {
  if (process.env.NODE_ENV !== 'production') { console.log('User ref changed, do something!'); }
});
</script>

<template>
  <v-app v-if="User">
    <v-main>
      <ModalView />
      <div class="content">
        <MainNav class="main-nav" />
        <div
            class="route-holder"
            :class="showBlock"
        >
          <router-view class="route-container" />
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import ModalView from './components/modal/ModalView';
import MainNav from '@/components/nav/MainNav';
import { useRMTStore } from '@/store/RMTStore';

export default {
  components: {
    ModalView,
    MainNav
  },

  computed: {
    showBlock () {
      const RMTStore = useRMTStore();
      return (RMTStore.RMTEditMode && !RMTStore.inCreateCollectionMode) ? 'block' : '';
    }
  },
  mounted () {
  },
};
</script>

<style scoped>
.content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.main-nav {
  align-self: flex-start;
}
.route-container {
  display: flex;
  max-width: 1500px;
}
.route-holder {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
}

.block {
  background-color: rgba(238,238,238,.85);
  transition: .2s background-color;
}

</style>